// components/FullPageLoader.jsx
import '../app.css';

export default function FullPageLoader() {
  return (
<div className="loading-overlay" id="loading-overlay">
  <div className="loading-spinner"></div>
</div>
  );
}